export const DATA_REF_NAME: string = 'data-ref-name';
export const DATA_IS_ACTIVE: string = 'data-is-active';
export const DATA_IS_PASSWORD_CHANGE_REQUIRED: string = 'data-is-password-change-required';
export const DATA_IS_ANALYZABLE: string = 'data-is-analyzable';
export const DATA_CONTENT_ITEM_ID: string = 'data-content-item-id';
export const DATA_ATTACHMENT_ID: string = 'data-attachment-id';
export const DATA_TAG_ID: string = 'data-tag-id';
export const DATA_USER_ID: string = 'data-user-id';
export const DATA_ASSET_ID: string = 'data-asset-id';
export const DATA_PORTFOLIO_GROUP_ID: string = 'data-portfolio-group-id';
export const DATA_PORTFOLIO_ID: string = 'data-portfolio-id';
export const DATA_ACCOUNT_ID: string = 'data-account-id';
export const DATA_DEAL_TEMPLATE_ID: string = 'data-deal-template-id';
export const DATA_ACTIVITY_ID: string = 'data-activity-id';
export const DATA_ACTIVITY_CATEGORY: string = 'data-activity-category';
export const DATA_DEAL_ID: string = 'data-deal-id';
export const DATA_DEAL_STATUS: string = 'data-deal-status';
export const DATA_DEAL_TERM_ID: string = 'data-deal-term-id';
export const DATA_DEAL_TERM_GROUP_ID: string = 'data-deal-term-group-id';
export const DATA_DEAL_VALUATION_FILE_ID: string = 'data-deal-valuation-file-id';
export const DATA_DEAL_TASK_ID: string = 'data-deal-task-id';
export const DATA_DEAL_TASK_GROUP_ID: string = 'data-deal-task-group-id';
export const DATA_DEAL_PARTICIPANT_ID: string = 'data-deal-participant-id';
export const DATA_DEAL_FILE_ID: string = 'data-deal-file-id';
export const DATA_DEAL_FILE_GROUP_ID: string = 'data-deal-file-group-id';
export const DATA_CONTACT_ID: string = 'data-contact-id';
export const DATA_REPORT_ID: string = 'data-report-id';
